import whitelistedCountries from "../config/whitelistedCountries";

/**
 * 
 * @param {string} iso - The country code to check
 * @returns {boolean} - Returns true if the country is whitelisted, false otherwise
 */
const isCountryWhitelisted = (iso) => {
  return whitelistedCountries.includes(iso);
};

export default isCountryWhitelisted;